import { produce } from 'immer';

import { UpdateInternalBannerImage } from '../../../actions/imageEditor/internal/updateInternalBannerImage';
import { getImageEditorIdByBannerId } from '../../../service/ImageHelpers/ImageHelpers';
import { ImageEditorsState } from '../../../typings/state';
import { getBannerImageUploadedState } from '../../imageEditor';

export function updateInternalBannerImage(
    state: ImageEditorsState,
    action: UpdateInternalBannerImage
): ImageEditorsState {
    const id = getImageEditorIdByBannerId(action.bannerId, action.resourceId);

    return produce(state, draft => {
        draft[id].image = {
            ...draft[id].image,
            ...getBannerImageUploadedState(action.image)
        };
        draft[id].image.data = action.image;
        draft[id].imageUploadingLink = '';
    });
}
